import './libs/modernizr.js';
import './libs/bootstrap';

// JS class helper
var body = document.querySelector('body');
body.classList.add('js');

// To top body class helper
// window.onscroll = function(e) {
//     if (window.pageYOffset > 500) {
//         body.classList.add('show-to-top');
//     } else {
//         body.classList.remove('show-to-top');
//     }
// };

// Touch body class helper
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    body.classList.add('touch');
}

require('./modules/headroom')
require('./modules/lazy-load')
require('./modules/slider')
require('./modules/slick-swiper')
require('./modules/map')
require('./modules/ajax-form-handler')
require('./modules/aos')
require('./modules/sidebars')
// require('./modules/tabs')
require('./modules/ibe')
require('./modules/ajax-posts')
require('./modules/dates')
require('./libs/jquery.lbt-lightbox.js')
require('./modules/lightbox')

// Stimulus
import { Application } from "stimulus"

import DelayVisibilityController from "./controllers/delay_visibility_controller"
import ProgressController from "./controllers/progress_controller"
import SnapScrollingController from "./controllers/snap_scrolling_controller"

const application = Application.start()
application.register("delay-visibility", DelayVisibilityController)
application.register("progress", ProgressController)
application.register("snap-scrolling", SnapScrollingController)